import { create } from 'zustand';

interface MessengerInboxState {
  selectedConversationId: string | null;
  showAgentConfig: boolean;
  setSelectedConversationId: (id: string | null) => void;
  clearSelectedConversationId: () => void;
  toggleAgentConfig: () => void;
  setShowAgentConfig: (show: boolean) => void;
}

export const useMessengerInboxStore = create<MessengerInboxState>((set) => ({
  selectedConversationId: null,
  showAgentConfig: false,
  setSelectedConversationId: (id) => set({ selectedConversationId: id }),
  clearSelectedConversationId: () => set({ selectedConversationId: null }),
  toggleAgentConfig: () => set((s) => ({ showAgentConfig: !s.showAgentConfig })),
  setShowAgentConfig: (show) => set({ showAgentConfig: show }),
}));
